import React, { FC, useRef } from 'react';
import { Page, selectTemplateDocument, selectPageOrientationById } from 'features/document/documentSlice';
import ContentSection from 'pages/DocumentBuilder/components/ContentSection/ContentSection';
import HeaderSection from 'pages/DocumentBuilder/components/HeaderSection/HeaderSection';
import styles from './Thumbnail.module.css';
import FooterSection from 'pages/DocumentBuilder/components/FooterSection/FooterSection';
import { ThumbnailContainer } from './Thumbnail.styled';
import { useGetFileQuery } from 'features/files/filesApi';
import { useAppSelector } from 'app/hooks';

interface Props {
  content: Page;
  totalPages: number;
  pageNumber: number;
  onClickEvent?: () => void;
}

const Thumbnail: FC<Props> = ({ content, pageNumber, totalPages, onClickEvent }) => {
  const {
    header,
    id,
    isIndividualHeaderVisible,
    rows,
    footer,
    isIndividualFooterVisible,
    backgroundColor,
    alignment,
    backgroundImageOpacity,
    backgroundImageId,
    showBackgroundColor,
    showBackgroundImage,
  } = content;
  const { isOrientedHorizontally } = useAppSelector(selectTemplateDocument);
  const isOrientedHorizontallySinglePage = useAppSelector(state => selectPageOrientationById(state, id));

  const { data: backgroundImageData } = useGetFileQuery(Number(backgroundImageId), {
    skip: !backgroundImageId,
  });

  const pageRef = useRef<HTMLDivElement>(null);

  return (
    <ThumbnailContainer
      id={id}
      tabIndex={0}
      className={`${styles.page} ${styles.pageThumbnail}`}
      ref={pageRef}
      onClick={onClickEvent}
      onKeyDown={() => {}}
      role='button'
      backgroundColor={showBackgroundColor ? backgroundColor : 'white'}
      backgroundImageOpacity={backgroundImageOpacity}
      backgroundPosition={alignment}
      backgroundImage={showBackgroundImage && backgroundImageId ? backgroundImageData?.data.url : ''}
      isOrientedHorizontally={isOrientedHorizontally}
      isOrientedHorizontallySinglePage={isOrientedHorizontallySinglePage}
    >
      <HeaderSection pageId={id} header={header} isIndividualHeaderVisible={isIndividualHeaderVisible} />
      <ContentSection pageId={id} rows={rows} />
      <div className={styles.footerPosition}>
        <FooterSection
          pageId={id}
          footer={footer}
          isIndividualFooterVisible={isIndividualFooterVisible}
          totalPages={totalPages}
          pageNumber={pageNumber}
        />
      </div>
    </ThumbnailContainer>
  );
};

export default Thumbnail;
